import { getEnv } from '@/utils/utils'
// 运行环境
const ENV = getEnv()

// 挂载环境变量至window(不能删)
window.env = ENV

let LIVEAUTH_URI = '' // 鉴权域名
let SHOP_URL = '' // 电商请求 API
let HOMEMINIURI = '' // 家居
let FIXUP_URL = ''
let AI_URL = '' // AI平台接口
let MARKET_URL = '' // 营销接口
let SUBSCRIBE_URI = '' // 订阅接口
let USER_URL = ''
let LIVE_GW_URL = ''
let LIVE_MAIN = ''
let LIVE_MEETING_URL = ''
let LIVE_INTERFACE_URL = ''
let ZHIBO_URL = ''
let LIVE_PALY_URL = ''
let BILL_URL = ''
let UPLOAD_URL = ''
let BILL_API_URL = ''
let LIVEPAY_URL = ''
let SCRM_URL = ''
let LIVE_API = ''
let YWSINK_API = ''
let LIVE_STREAM = ''
let wxHost = ''
let ZHIBO_API = ''
let WechatApp = ''
let gwServer = '' // 镇鹏用于优化下单高并发的网关
let GUO_KE_URL = '' // 国科API
let PERM_GW_URL = ''
let TRIAL_URL = ''
let liveGwRetry = ''
let VZAN_STORE_BASE_URL = ''
let FRONT_URL = ''
/** 门店pc后台 */
let STORE_PC_URL = ''
let WX_API = ''
/** 超级群发后台 */
let NOTIFY = ''
let liveMarketApi
// ENV

switch (ENV) {
  case 'dev':
    liveGwRetry = 'https://ypgw-dev.vzan.com'
    wxHost = 'https://wx-dev.vzan.com'
    LIVEAUTH_URI = 'https://liveauth-dev.vzan.com'
    SHOP_URL = 'https://shop-dev.vzan.com'
    HOMEMINIURI = 'https://live-cptapi-dev.vzan.com/home'
    FIXUP_URL = 'https://live-liveapi-dev.vzan.com'
    AI_URL = 'https://ai-dev.vzan.com/platform'
    MARKET_URL = 'https://live-cptapi-dev.vzan.com/yxapi'
    SUBSCRIBE_URI = 'https://live-gateway-dev.vzan.com'
    USER_URL = 'https://liveapi-dev.vzan.com'
    LIVE_GW_URL = 'https://live-gw-dev.vzan.com'
    LIVE_MAIN = 'https://livemain-dev.vzan.com'
    LIVE_MEETING_URL = 'https://live-meeting-dev.vzan.com'
    // LIVE_MAIN = 'http://192.168.60.192:8080'
    LIVE_INTERFACE_URL = 'https://live-interface-dev.vzan.com'
    ZHIBO_URL = 'https://live-capi-dev.vzan.com'
    LIVE_PALY_URL = 'https://live-play-dev.vzan.com'
    BILL_URL = 'https://bill-dev.vzan.com'
    UPLOAD_URL = 'https://live-dev.vzan.com'
    BILL_API_URL = 'https://bill-dev.vzan.com'
    LIVEPAY_URL = 'https://livepay-dev.vzan.com'
    SCRM_URL = 'https://scrm-dev.vzan.com'
    LIVE_API = 'https://tliveapi.vzan.com'
    YWSINK_API = 'https://ywsink-dev.vzan.com'
    LIVE_STREAM = 'https://liveStream-dev.weizan.cn'
    ZHIBO_API = 'https://zhibo-dev.vzan.com'
    WechatApp = 'https://live-wechatapp-dev.vzan.com'
    gwServer = 'https://gwserver-dev.vzan.com/shop'
    gwServer = 'https://gwserver-dev.vzan.com/shop'
    GUO_KE_URL = 'https://guoke-dev.lnlangche.cn'
    VZAN_STORE_BASE_URL = 'https://live-gw-dev.vzan.com'
    FRONT_URL = 'https://wx-dev.vzan.com'
    PERM_GW_URL = 'https://perm-gw-dev.vzan.com/admin'
    TRIAL_URL = 'https://trial-dev.vzan.com'
    STORE_PC_URL = 'https://sp-dev.vzan.com'
    WX_API = 'https://minivt-dev.vzan.com'
    NOTIFY = 'https://notify-dev.jzxfxx.net'
    liveMarketApi = 'https://live-marketapi-dev.vzan.com'
    break
  case 'test':
    liveGwRetry = 'https://ypgw-test.vzan.com'
    wxHost = 'https://testvt.vzan.com'
    LIVEAUTH_URI = 'https://liveauth-test.vzan.com'
    SHOP_URL = 'https://shop-test.vzan.com'
    HOMEMINIURI = 'https://live-cptapi-test.vzan.com/home'
    FIXUP_URL = 'https://live-liveapi-test.vzan.com'
    AI_URL = 'https://ai-test.vzan.com/platform'
    MARKET_URL = 'https://live-cptapi-test.vzan.com/yxapi'
    SUBSCRIBE_URI = 'https://live-gateway-test.vzan.com'
    USER_URL = 'https://liveapi-test.vzan.com'
    LIVE_GW_URL = 'https://live-gw-test.vzan.com'
    LIVE_MAIN = 'https://livemain-test.vzan.com'
    LIVE_MEETING_URL = 'https://live-meeting-test.vzan.com'
    LIVE_INTERFACE_URL = 'https://live-interface-test.vzan.com'
    ZHIBO_URL = 'https://live-capi-test.vzan.com'
    LIVE_PALY_URL = 'https://live-play-test.vzan.com'
    BILL_URL = 'https://bill-test.vzan.com'
    UPLOAD_URL = 'https://wtest.vzan.com'
    BILL_API_URL = 'https://bill-test.vzan.com'
    LIVEPAY_URL = 'https://livepay-test.vzan.com'
    SCRM_URL = 'https://scrm-test.vzan.com'
    LIVE_API = 'https://tliveapi.vzan.com'
    YWSINK_API = 'https://ywsink-test.vzan.com'
    LIVE_STREAM = 'https://liveStream-test.weizan.cn'
    ZHIBO_API = 'https://zhibo-test.vzan.com'
    WechatApp = 'https://live-wechatapp-test.vzan.com'
    gwServer = 'https://gwserver-test.vzan.com/shop'
    GUO_KE_URL = 'https://guoke-test.lnlangche.cn'
    VZAN_STORE_BASE_URL = 'https://live-gw-test.vzan.com'
    FRONT_URL = 'https://testvt.vzan.com'
    PERM_GW_URL = 'https://perm-gw-test.vzan.com/admin'
    TRIAL_URL = 'https://trial-test.vzan.com'
    STORE_PC_URL = 'https://sp-test.vzan.com'
    WX_API = 'https://minivt-test.vzan.com'
    NOTIFY = 'https://notify-test.jzxfxx.net'
    liveMarketApi = 'https://live-marketapi-test.vzan.com'
    break
  case 'pre':
    liveGwRetry = 'https://ypgw-pre.vzan.com'
    wxHost = 'https://ntestvt.vzan.com'
    LIVEAUTH_URI = 'https://liveauth.vzan.com'
    SHOP_URL = 'https://shop-pre.vzan.com'
    HOMEMINIURI = 'https://live-cptapi-pre.vzan.com/home'
    FIXUP_URL = 'https://live-liveapi-pre.vzan.com'
    AI_URL = 'https://ai-pre.vzan.com/platform'
    MARKET_URL = 'https://live-cptapi-pre.vzan.com/yxapi'
    SUBSCRIBE_URI = 'https://live-gateway.vzan.com'
    USER_URL = 'https://liveapi-pre.vzan.com'
    LIVE_GW_URL = 'https://live-gw-pre.vzan.com'
    LIVE_MAIN = 'https://livemain-pre.vzan.com'
    LIVE_MEETING_URL = 'https://live-meeting-pre.vzan.com'
    LIVE_INTERFACE_URL = 'https://live-interface-pre.vzan.com'
    ZHIBO_URL = 'https://live-capi-pre.vzan.com'
    LIVE_PALY_URL = 'https://live-play-pre.vzan.com'
    BILL_URL = 'https://bill-pre.vzan.com'
    UPLOAD_URL = 'https://tuser.vzan.com'
    BILL_API_URL = 'https://bill-pre.vzan.com'
    LIVEPAY_URL = 'https://livepay-pre.vzan.com'
    SCRM_URL = 'https://scrm-pre.vzan.com'
    LIVE_API = 'https://liveapi-pre.vzan.com'
    YWSINK_API = 'https://ywsink-pre.vzan.com'
    LIVE_STREAM = 'https://liveStream-pre.weizan.cn'
    ZHIBO_API = 'https://zhibo-pre.vzan.com'
    WechatApp = 'https://live-wechatapp-pre.vzan.com'
    gwServer = 'https://gwserver-pre.vzan.com/shop'
    GUO_KE_URL = 'https://guoke-pre.lnlangche.cn'
    VZAN_STORE_BASE_URL = 'https://live-gw-pre.vzan.com'
    FRONT_URL = 'https://ntestvt.vzan.com'
    PERM_GW_URL = 'https://perm-gw-pre.vzan.com/admin'
    TRIAL_URL = 'https://trial-pre.vzan.com'
    STORE_PC_URL = 'https://sp-pre.vzan.com'
    WX_API = 'https://minivt-pre.vzan.com'
    NOTIFY = 'https://notify-pre.jzxfxx.net'
    liveMarketApi = 'https://live-marketapi-pre.vzan.com'
    break
  case 'prod':
    liveGwRetry = 'https://ypgw.vzan.com'
    wxHost = 'https://wx.vzan.com'
    LIVEAUTH_URI = 'https://liveauth.vzan.com'
    SHOP_URL = 'https://shop.vzan.com'
    HOMEMINIURI = 'https://live-cptapi.vzan.com/home'
    FIXUP_URL = 'https://live-liveapi.vzan.com'
    AI_URL = 'https://ai.vzan.com/platform'
    MARKET_URL = 'https://live-cptapi.vzan.com/yxapi'
    SUBSCRIBE_URI = 'https://live-gateway.vzan.com'
    USER_URL = 'https://liveapi.vzan.com'
    LIVE_GW_URL = 'https://live-gw.vzan.com'
    LIVE_MAIN = 'https://livemain.vzan.com'
    LIVE_MEETING_URL = 'https://live-meeting.vzan.com'
    LIVE_INTERFACE_URL = 'https://live-interface.vzan.com'
    ZHIBO_URL = 'https://live-capi.vzan.com'
    LIVE_PALY_URL = 'https://live-play.vzan.com'
    BILL_URL = 'https://bill.vzan.com'
    UPLOAD_URL = 'https://live.vzan.com'
    BILL_API_URL = 'https://bill.vzan.com'
    LIVEPAY_URL = 'https://livepay.vzan.com'
    SCRM_URL = 'https://scrm.vzan.com'
    LIVE_API = 'https://liveapi.vzan.com'
    YWSINK_API = 'https://ywsink.vzan.com'
    LIVE_STREAM = 'https://liveStream.weizan.cn'
    ZHIBO_API = 'https://zhibo.vzan.com'
    WechatApp = 'https://live-wechatapp.vzan.com'
    gwServer = 'https://gwserver.vzan.com/shop'
    GUO_KE_URL = 'https://guoke.lnlangche.cn'
    VZAN_STORE_BASE_URL = 'https://live-gw.vzan.com'
    FRONT_URL = 'https://wx.vzan.com'
    PERM_GW_URL = 'https://perm-gw.vzan.com/admin'
    TRIAL_URL = 'https://trial.vzan.com'
    STORE_PC_URL = 'https://sp.vzan.com'
    WX_API = 'https://ds.vzan.com'
    NOTIFY = 'https://notify.jzxfxx.net'
    liveMarketApi = 'https://live-marketapi.vzan.com'
    break
  default:
    liveGwRetry = 'https://ypgw.vzan.com'
    wxHost = 'https://wx.vzan.com'
    LIVEAUTH_URI = 'https://liveauth.vzan.com'
    SHOP_URL = 'https://shop.vzan.com'
    HOMEMINIURI = 'https://live-cptapi.vzan.com/home'
    FIXUP_URL = 'https://live-liveapi.vzan.com'
    AI_URL = 'https://ai.vzan.com/platform'
    MARKET_URL = 'https://live-cptapi.vzan.com/yxapi'
    SUBSCRIBE_URI = 'https://live-gateway.vzan.com'
    USER_URL = 'https://liveapi.vzan.com'
    LIVE_GW_URL = 'https://live-gw.vzan.com'
    LIVE_MAIN = 'https://livemain.vzan.com'
    LIVE_MEETING_URL = 'https://live-meeting.vzan.com'
    LIVE_INTERFACE_URL = 'https://live-interface.vzan.com'
    ZHIBO_URL = 'https://live-capi.vzan.com'
    LIVE_PALY_URL = 'https://live-play.vzan.com'
    BILL_URL = 'https://bill.vzan.com'
    UPLOAD_URL = 'https://live.vzan.com'
    BILL_API_URL = 'https://bill-dev.vzan.com'
    LIVEPAY_URL = 'https://livepay.vzan.com'
    SCRM_URL = 'https://scrm.vzan.com'
    LIVE_API = 'https://liveapi.vzan.com'
    YWSINK_API = 'https://ywsink.vzan.com'
    LIVE_STREAM = 'https://liveStream.weizan.cn'
    ZHIBO_API = 'https://zhibo.vzan.com'
    WechatApp = 'https://live-wechatapp.vzan.com'
    GUO_KE_URL = 'https://guoke.lnlangche.cn'
    VZAN_STORE_BASE_URL = 'https://live-gw.vzan.com'
    FRONT_URL = 'https://wx.vzan.com'
    PERM_GW_URL = 'https://perm-gw.vzan.com/admin'
    TRIAL_URL = 'https://trial.vzan.com'
    STORE_PC_URL = 'https://sp.vzan.com'
    WX_API = 'https://ds.vzan.com'
    NOTIFY = 'https://notify.jzxfxx.net'
    liveMarketApi = 'https://live-marketapi.vzan.com'
}

try {
  if (window.PRIVATE_CLIENT && !window.PRIVATE_CLIENT.HOST.includes('vzan')) {
    let BaseUrlData = {
      SHOP_URL,
      LIVEAUTH_URI,
      HOMEMINIURI,
      FIXUP_URL,
      MARKET_URL,
      liveGwRetry,
      SUBSCRIBE_URI,
      USER_URL,
      LIVE_GW_URL,
      LIVE_MAIN,
      LIVE_MEETING_URL,
      LIVE_INTERFACE_URL,
      ZHIBO_URL,
      LIVE_PALY_URL,
      UPLOAD_URL,
      BILL_API_URL,
      LIVEPAY_URL,
      LIVE_API,
      LIVE_STREAM,
      ZHIBO_API,
    }
    for (const key in BaseUrlData) {
      if (Object.hasOwnProperty.call(BaseUrlData, key)) {
        const el = BaseUrlData[key]
        BaseUrlData[key] = el.replace('.vzan.com', window.PRIVATE_CLIENT.HOST)
      }
    }
    SHOP_URL = BaseUrlData.SHOP_URL
    LIVEAUTH_URI = BaseUrlData.LIVEAUTH_URI
    HOMEMINIURI = BaseUrlData.HOMEMINIURI
    FIXUP_URL = BaseUrlData.FIXUP_URL
    MARKET_URL = BaseUrlData.MARKET_URL
    liveGwRetry = BaseUrlData.liveGwRetry
    SUBSCRIBE_URI = BaseUrlData.SUBSCRIBE_URI
    USER_URL = BaseUrlData.USER_URL
    LIVE_GW_URL = BaseUrlData.LIVE_GW_URL
    LIVE_MAIN = BaseUrlData.LIVE_MAIN
    LIVE_MEETING_URL = BaseUrlData.LIVE_MEETING_URL
    LIVE_INTERFACE_URL = BaseUrlData.LIVE_INTERFACE_URL
    ZHIBO_URL = BaseUrlData.ZHIBO_URL
    LIVE_PALY_URL = BaseUrlData.LIVE_PALY_URL
    UPLOAD_URL = BaseUrlData.UPLOAD_URL
    BILL_API_URL = BaseUrlData.BILL_API_URL
    LIVEPAY_URL = BaseUrlData.LIVEPAY_URL
    SCRM_URL = 'https://scrm.vzan.com'
    LIVE_API = BaseUrlData.LIVE_API
    LIVE_STREAM = BaseUrlData.LIVE_STREAM
    wxHost = BaseUrlData.wxHost
    ZHIBO_API = BaseUrlData.BaseUrlData
  }
} catch (error) {
  console.log(error)
}
const homeminiToLiveGw = function () {
  return (() => {
    // let isGrayLive = JSON.parse(localStorage.getItem('isGrayLive'))
    // return isGrayLive ? LIVE_GW_URL + '/marketing' : HOMEMINIURI
    return LIVE_GW_URL + '/marketing'
  })()
}
export {
  SHOP_URL,
  LIVEAUTH_URI,
  HOMEMINIURI,
  FIXUP_URL,
  AI_URL,
  MARKET_URL,
  liveGwRetry,
  SUBSCRIBE_URI,
  USER_URL,
  LIVE_GW_URL,
  LIVE_MAIN,
  TRIAL_URL,
  LIVE_MEETING_URL,
  LIVE_INTERFACE_URL,
  ZHIBO_URL,
  LIVE_PALY_URL,
  BILL_URL,
  UPLOAD_URL,
  BILL_API_URL,
  LIVEPAY_URL,
  SCRM_URL,
  LIVE_API,
  YWSINK_API,
  LIVE_STREAM,
  wxHost,
  ZHIBO_API,
  WechatApp,
  PERM_GW_URL,
  gwServer,
  homeminiToLiveGw,
  GUO_KE_URL,
  VZAN_STORE_BASE_URL,
  FRONT_URL,
  STORE_PC_URL,
  WX_API,
  NOTIFY,
  liveMarketApi,
}
